"use client";

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { useViewerLanguage } from "@/lib/i18n";

export function OriginalSlideDialog({
  open,
  onOpenChange,
  url,
  slideNumber,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  url: string | null;
  slideNumber: number | null;
}) {
  const { t } = useViewerLanguage();
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="gap-3 p-4 sm:max-w-5xl sm:p-5">
        <DialogHeader className="pr-8">
          <DialogTitle className="text-base">
            {slideNumber != null
              ? t("Original slide {number}", { number: slideNumber })
              : t("Original slide")}
          </DialogTitle>
          <DialogDescription className="sr-only">
            {t("The presentation slide this page was created from")}
          </DialogDescription>
        </DialogHeader>
        <div className="flex aspect-video max-h-[calc(100dvh-8rem)] w-full items-center justify-center overflow-hidden rounded-md bg-muted">
          {url ? (
            <img
              src={url}
              alt={
                slideNumber != null
                  ? t("Slide {number}", { number: slideNumber })
                  : t("Original slide")
              }
              className="size-full object-contain"
            />
          ) : (
            <p className="text-sm text-muted-foreground">
              {t("No preview available")}
            </p>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
